import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@material-ui/core";

import CustomAlert from "./CustomAlert";
import CustomDialog from "./CustomDialog";
import useLocale from "../../hooks/useLocale";
import { useMutation } from "react-query";
import { useState } from "react";

const CustomDeleteDialog = ({
  open,
  close,
  refetch,
  selectedItem,
  title,
  message,
  deleteService,
  fieldName,
  idFieldName = "id",
}) => {
  const [error, setError] = useState("");
  const { t } = useLocale();
  // Delete mutation
  const { mutate } = useMutation(deleteService, {
    onSuccess: (data) => {
      refetch();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured, please try again later"));
        }
      }
    },
  });

  const handleDeleteItem = () => {
    mutate({ items: JSON.stringify([selectedItem?.[idFieldName]]) });
  };

  return (
    <CustomDialog
      open={open}
      maxWidth="sm"
      onClose={() => {
        close();
        setError("");
      }}
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <Typography>
          {message}
          <b> "{selectedItem[fieldName]}"</b>
          {t("?")}
        </Typography>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <DialogActions>
        <Button
          onClick={() => {
            handleDeleteItem();
          }}
          color="primary"
        >
          {t("Delete")}
        </Button>
        <Button
          onClick={() => {
            close();
            setError("");
          }}
          color="primary"
        >
          {t("Cancel")}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default CustomDeleteDialog;
